import axios from "axios";
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router";

import DoctorsFilterOptions from "../../../../components/Common/CommonFilterOptions";
import NavBarTitles from "../../../../components/Common/TabBar";

import moment from "moment/moment";
import "../index.scss";
// Updated custom hook paths
import apiCall from "../../../../components/Api";
import Breadcrumbs from "../../../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import SelectComponent from "../../../../components/Common/Select";
import ListPageLayout from "../../../../components/Layout";

const DoctorsReportError = ({ type }) => {
  const navigate = useNavigate();
  const [del, setDel] = useState(false);
  const [id] = useState("");

  const handleDelete = (id) => {
    fetch(`${process.env.REACT_APP_API_URL}doctors-report/delete/${id}`, {
      method: "DELETE",
    }).then((result) => {
      result.json().then((res) => {
        list_api_call();
        setDel(false);
      });
    });
  };

  const [filtered_records, setFilteredRecords] = useState([]);
  // const [rows_count, setRowCount] = useState(0);
  const [pages, setPages] = useState(0);
  const [current_page, setCurrentPage] = useState(1);
  const [skip, setSkip] = useState(0);
  const [limit, setLimit] = useState(10);
  const [sort, setSort] = useState("newest");
  const [sortName, setSortName] = useState("Sort by");
  const [filter] = useState({});
  const [records, setRecords] = useState([]);
  const [loader, setLoader] = useState(true);

  const [sortshow, setSortShow] = useState(false);
  const [textcolor, setTextColor] = useState(0);
  const [filtershow, setFilterShow] = useState(false);
  const [, setSubmitFilter] = useState(false);

  useEffect(() => {
    setLoader(true)
    list_api_call();
  }, [filter, limit, sort, skip, type]);

  useEffect(() => {
    if (current_page > 1) {
      setSkip((current_page - 1) * limit);
    } else {
      setSkip(0);
    }
  }, [current_page]);

  const list_api_call = async () => {
    try {
      let response;
      if (type === "online-doctor") {
        response = await apiCall(`doctors-report/list`, "POST", {
          ...filter,
          skip: skip,
          limit: limit,
          sort: sort,
        });
      } else {
        response = await apiCall(`clinic-report/list`, "POST", {
          ...filter,
          skip: skip,
          limit: limit,
          sort: sort,
          clinicProfile: type === "clinic",
        });
      }
      if (response) {
        setFilteredRecords([]);
        setRecords(response.data.rows);
        // setRowCount(response.data.count);
        setPages(Math.ceil(response.data.count / limit));
      } else {
        console.error("err");
      }
    } catch (err) {
      console.error(err);
      alert(err);
    }
  };

  const filter_records = (filter) => {
    let rows = records.filter((x) => {
      return JSON.stringify(x).toLowerCase().indexOf(filter.toLowerCase()) > -1;
    });
    setFilteredRecords(rows);
  };
  const tabName =
    window.location.pathname === "/doctors-report"
      ? "doctors-report"
      : "clinic-report";
  const handleAccept = (id) => {
    setLoader(true)
    axios
      .patch(`${process.env.REACT_APP_API_URL}${tabName}/update/${id}`, {
        accept: true,
        reject: false,
        clinicProfile:
          window.location.pathname === "/clinics-report" ? true : false,
      })
      .then((result) => {
        list_api_call();
      });
  };

  const handleReject = (id) => {
    setLoader(true)
    axios
      .patch(`${process.env.REACT_APP_API_URL}${tabName}/update/${id}`, {
        accept: false,
        reject: true,
        clinicProfile:
          window.location.pathname === "/clinics-report" ? true : false,
      })
      .then((result) => {
        list_api_call();
      });
  };
  const columns = [
    { title: "S.No", dataIndex: "serial", key: "serial", fixed: "left" },
    {
      title: type === "clinic" ? "Clinic Name" : "Doctor Name",
      dataIndex: "specialization",
      key: "specialization",
      fixed: "left",
    },
    { title: "What do you want to report", dataIndex: "report", key: "report" },
    { title: "Name", dataIndex: "name", key: "name" },
    { title: "Email", dataIndex: "email", key: "email" },
    { title: "Mobile Number", dataIndex: "mobile", key: "mobile" },
    { title: "Brief about your concern", dataIndex: "concern", key: "concern" },
    { title: "Received Time", dataIndex: "receivedTime", key: "receivedTime" },
    { title: "Received Date", dataIndex: "receivedDate", key: "receivedDate" },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => (
        <span
          style={{
            color:
              text === "Accepted"
                ? "green"
                : text === "Rejected"
                  ? "red"
                  : "gray",
          }}
        >
          {text}
        </span>
      ),
    },
    { title: "Who are you", dataIndex: "whoAreYou", key: "whoAreYou" },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <div className="d-flex align-items-center">
          <SelectComponent
            props={{
              Array: ["Accept", "Reject"],
              value: record?.status,
              style: { color: "#CB1B5B", width: "200px" },
              onChange: async (e) => {
                if (e === "Accept") {
                  handleAccept(record.actions);
                } else if (e === "Reject") {
                  handleReject(record.actions);
                }
              },
            }}
          />
        </div>
      ),
    },
  ];

  const dataSource = (
    filtered_records.length > 0 ? filtered_records : records
  ).map((el, i) => ({
    key: el._id,
    serial: i + 1,
    specialization:
      type === "clinic" ? el.clinic_name || "-" : el.doctor_name || "-",
    report: el.report,
    name: el.name,
    email: el.email,
    mobile: el.mobile,
    concern: el.concern,
    receivedTime: moment(el.createdAt).format("LT"),
    receivedDate: moment(el.createdAt).format("DD-MM-YYYY"),
    status: el.accept ? "Accepted" : el.reject ? "Rejected" : "Pending",
    whoAreYou: el.who_are_you,
    actions: el._id,
  }));

  const breadcrumbsList = useMemo(
    () => [
      {
        text: "Doctor",
        link: "/add-new-doctors",
      },

      {
        text: "Report an error",
        link: "",
      },
    ],
    [],
  );

  const DocterReportnavBarData = [
    {
      name: "Online Doctor",
      navigatePath: "/doctors-report",
    },
    { name: "InClinic Doctor", navigatePath: "/inclinic-doctors-report" },
    { name: "Clinic Profile", navigatePath: "/clinics-report" },
  ];

  useEffect(() => {
    records && setTimeout(() => setLoader(false));
  }, [records]);

  return (
    <ListPageLayout
      breadcrumbs={
        <Breadcrumbs
          className="healthsyMasterBreadCrumbs"
          breadcrumbsList={breadcrumbsList}
        />
      }
      titles={<NavBarTitles titles={DocterReportnavBarData} />}
      filters={
        <DoctorsFilterOptions
          limit={limit}
          setLimit={(val) =>
            setPages((prev) => ({
              ...prev,
              limit: val,
              skip: 0,
              currentPage: 1,
            }))
          }
          // search={search}
          // onChange={debouncedSearch}
          // handleSortClick={handleSortClick}
          sortName={sortName}
          filter_records={() => {}}
          showFilter={false}
        />
      }
      tableProps={{
        columns,
        dataSource,
      }}
      // totalCount={pages}
      loader={loader}
      pagination={pages}
    >
      {/* Optional children like modals */}
    </ListPageLayout>
  );
};

export default DoctorsReportError;
